import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as BeaconService from "_services/beacons-service";

// initial state of slice
const initialState = {
    beaconList: [],
    loading: false,
    error: null,
};

export const getBeaconList = createAsyncThunk(
    "beacons/getBeaconList",
    async (params) => {
        return BeaconService.getBeaconList(params);
    }
);

const assetTrackingSlice = createSlice({
    name: "assetTracking",
    initialState,
    reducers: {
        reset: (state) => {
            state.beaconList = [];
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getBeaconList.pending, (state) => {
                state.beaconList = [];
                state.loading = true;
                state.error = null;
            })
            .addCase(getBeaconList.fulfilled, (state, action) => {
                state.beaconList = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getBeaconList.rejected, (state, action) => {
                console.error("Failed to fetch UUID and coordinates:", action.error);
                state.beaconList = [];
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export const selectBeaconList = (state) => state.assetTracking.beaconList;

export const { reset } = assetTrackingSlice.actions;
export default assetTrackingSlice.reducer;